module.exports = "//static.hsappstatic.net/connect-dot-com-public-ui/static-1.2998/images/connect-public-landing-page-sticky-button.svg"